export default {
	"toMarketing.ParameterError": "参数错误!",
	"toMarketing.CallIsComing": "叫叫正在赶来..."
}